export const TYPE_NONE            = false;
export const TYPE_CONTAINER       = 'container-list';
export const TYPE_EDITORIAL       = 'editorials';
export const TYPE_EDITORIAL_LIST  = 'editorials-list';
export const TYPE_INTERVIEW       = 'interview';
export const TYPE_TIMELINE        = 'timeline';
export const TYPE_TEMPLATE        = 'template';
export const TYPE_PROFILES        = 'profiles';
export const TYPE_JOBS            = 'jobs';
export const TYPE_TEMPLATES       = 'templates';
//export const TYPE_CASES           = 'cases';


export const EDITORIAL_TYPE_QA = 'QA';
export const EDITORIAL_TYPE_ARTICLE = 'ARTICLE';

export const EDITORIAL_SIDEBAR_TYPE_IMAGE = 'IMAGE';
export const EDITORIAL_SIDEBAR_TYPE_YOUTUBE = 'YOUTUBE';
export const EDITORIAL_SIDEBAR_TYPE_VIMEO = 'VIMEO';
export const EDITORIAL_SIDEBAR_TYPE_LINK = 'LINK';

export const DEVICE_DESKTOP = 'DEVICE_DESKTOP';
export const DEVICE_TABLET_PORTRAIT = 'DEVICE_TABLET_PORTRAIT';
export const DEVICE_TABLET_LANDSCAPE = 'DEVICE_TABLET_LANDSCAPE';
export const DEVICE_MOBILE_PORTRAIT = 'DEVICE_MOBILE_PORTRAIT';
export const DEVICE_MOBILE_LANDSCAPE = 'DEVICE_MOBILE_LANDSCAPE';



/** WEBPACK FOOTER **
 ** ./frontend/constants/types.js
 **/